
import { computed, defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default defineComponent({
  props: {
    linkUrl: {
      type: String,
      required: true,
    },
    linkTarget: {
      type: String,
      required: false,
    },
    linkTitle: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();

    const currentPage = computed(() => store.getters['pages/page']);
    const isCurrentlyVisited = computed(() => currentPage.value.url === props.linkUrl);
    const routePath = props.linkUrl.replace(window.location.origin, '');

    return {
      currentPage,
      isCurrentlyVisited,
      router,
      routePath,
    };
  },

  methods: {
    navigate(e: Event) {
      if ([undefined, null, '_self'].indexOf(this.linkTarget) >= 0) {
        e.preventDefault();
        this.router.push(this.routePath);
      }
    },
  },
});
